var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5401 10.42C26.4213 9.94541 26.1794 9.51057 25.8387 9.15941C25.4981 8.80824 25.0708 8.55318 24.6001 8.42C22.8801 8 16.0001 8 16.0001 8C16.0001 8 9.12008 8 7.40008 8.46C6.92933 8.59318 6.50206 8.84824 6.16143 9.19941C5.8208 9.55057 5.57887 9.98541 5.46008 10.46C5.1453 12.2056 4.99132 13.9763 5.00008 15.75C4.98886 17.537 5.14285 19.3213 5.46008 21.08C5.59104 21.5398 5.83839 21.9581 6.17823 22.2945C6.51806 22.6308 6.9389 22.8738 7.40008 23C9.12008 23.46 16.0001 23.46 16.0001 23.46C16.0001 23.46 22.8801 23.46 24.6001 23C25.0708 22.8668 25.4981 22.6118 25.8387 22.2606C26.1794 21.9094 26.4213 21.4746 26.5401 21C26.8524 19.2676 27.0064 17.5103 27.0001 15.75C27.0113 13.963 26.8573 12.1787 26.5401 10.42Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 19.02L19.5 15.75L13.75 12.48V19.02Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.20869e90df7dd71ab2aebbeec6d3d455.svg";
export { ForwardRef as ReactComponent };